export default {
  title: 'Szczegóły zamówienia',
  order_again: 'Zamów ponownie',
};
